module.exports = __webpack_public_path__ + "static/media/contactbg-india.51c8641d.jpg";